import React from 'react'

import SpinnerDiv from "./SpinnerDiv";
import Dropdown from "./ReactDropdown";

export default class DropdownQualification extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		let v =
			{
				mode: 'list',
				label: 'Select a Value',
				defaultValue: -1,
				maxValue: 99
			}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 0 ;

		if ( this.props.defaultValue == null || this.props.defaultValue > this.props.maxValue )
		{
			var def = -1 ;
		}
		else
		{
			def = this.props.defaultValue ;
		}

    	// Create a state item here
		this.state = { dirty: false, currentValue: def, items: [] };

		this.isDirty = this.isDirty.bind(this) ;
		this.setDirty = this.setDirty.bind(this) ;

	}

	UNSAFE_componentWillMount()
	{		
		this.getdata () ;
	}

	getdata( )
	{
		let values = [
			{
				id: 0,
				desc: 'Please select'
			},
			{
				id: 1,
				desc: 'GCSE'
			},
			{
				id: 2,
				desc: 'Functional Skills - Entry Level 1'
			},
			{
				id: 3,
				desc: 'Functional Skills - Entry Level 2'
			},
			{
				id: 4,
				desc: 'Functional Skills - Entry Level 3'
			},
			{
				id: 5,
				desc: 'Functional Skills - Level 1'
			},
			{
				id: 6,
				desc: 'Functional Skills - Level 2'
			},
			{
				id: 7,
				desc: 'BTEC'
			},
			{
				id: 8,
				desc: 'GNVQ'
			},
			{
				id: 99,
				desc: 'Other'
			},
		];
				
		this.setState ( { items : values } ) ;
	}

	handleChange(e) 
	{
		let index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		let offset = 0 ;

		if ( this.props.mode == 'filter')
		{
			offset = -1 ;
		}

		if ( index > 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.onChange != null )
		{
			this.props.onChange ( itemid ) ;
		}
		
	}
	  
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == -1)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == -1)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

    getValue()
    {
    	return this.state.currentValue ;
    }

	returnOption ( row )
	{
		return React.createElement ( 'option', {key: this.keyCount++, name: row.id, value: row.id} , row.desc ) ;
	}

	optionList ()
	{
		return this.state.items.map(element =>
		{
			return this.returnOption ( element ) ;
		});
	}

	dropdown_select ( id )
	{
		return React.createElement ( 'select', {key: this.keyCount++, value: this.getValue(), className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
	}

	render()
	{
		if ( this.props.readOnly != 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
	}
};


